<template>
  <div id="checkingRole">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      color="#f6f6fa"
    >
      <p style="color:#FFFFFF;background-color:#5555BB"><b>役割の確認</b></p>
      <div v-if="isHost">
        <div v-if="!sent">
          <p>役割を確認し，ホストユーザはボタンを押して，<br>ゲームを進めて下さい．</p>
          <div class="send-button">
            <sendButton v-on:pushed="start" label="進める" active="true"/>
          </div>
        </div>
        <div v-else>
          <span>ゲーム情報を取得しています．</span>
        </div>
      </div>
      <div v-else>
        <p>役割を確認し，ホストユーザはボタンを押して，<br>ゲームを進めて下さい．</p>
        <div class="send-button">
          <sendButton label="進める" active="false"/>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "checkingRole",
  plops: [],
  components: {
    sendButton
  },
  data() {
    return {
      socket: this.$store.state.webSocket.socket,
      roomId: this.$store.getters.roomId,
      userName: this.$store.getters.userName,
      userId: this.$store.getters.userId,
      isHost: this.$store.getters.isHost,
      sent: false,
    };
  },
  computed: {
    round () {
      return this.$store.state.missionInfo.round
    },
  },
  methods: {
    start() {
      // this.sent = true
      this.$emit("send-request", {"action": "start", "roomId": this.roomId, "userId": this.userId, data: {}})
    }
  },
  created (){
    var self = this
    this.socket.onmessage = function(event){

      // ゲームの初期化
      self.$store.commit('clearVotes')

      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}

      var nextState = "checking-plot"
      if (res.state == "checking-plot"){
        nextState = "checkingPlot"
        console.log(res)
        console.log(res.data)
        self.$store.commit('addDrawnPlots', {plots: res.data.plots, round:self.round})
        self.$emit("show-text", {state: "checking-role", text: "陰謀カードを引きました．"})

      } else if (res.state == "assigning-mission"){
        nextState = "assigningMission"
        self.$emit("show-text", {state: "checking-role", text: "ゲームが開始されました．"})
      }
      self.$emit("proceed-state", nextState)
    }
  }
}
</script>
<style>
#checkingRole .send-button {
  padding-bottom: 12px
}
</style>
